import React from "react";
import styled from "styled-components";
import { identity } from "lodash";
import { PanelPropertiesCard } from "@sonder/ui/source/styled/components/PanelPropertiesCard";
import { TaskData } from "core/queries/GetTask";
import { ParsedText } from "tasks/components/ParsedText";
import { Attachments } from "tasks/components/TaskPanel/Attachments";

// Exports
export const HOLD_DEPOSIT_INFO = {
  heading: "Hold On Security Deposit",
  options: [
    {
      label: "Reason for hold",
      path: "structuredMetadata.securityDepositReason",
      transform: identity,
    },
    {
      label: "Hold amount",
      path: "structuredMetadata.securityDepositAmount",
      transform: identity,
    },
  ],
};

const StyledAttachments = styled.div`
  margin-top: 0.5rem;
`;

export const HoldDepositCard = ({ task }: { task: TaskData }) => {
  return (
    <PanelPropertiesCard
      data={task}
      heading={HOLD_DEPOSIT_INFO.heading}
      options={[
        ...HOLD_DEPOSIT_INFO.options,
        ...(task.securityDepositItems || []).map(item => ({
          label: item.name || "Unnamed Task",
          path: "name",
          transform: () => (
            <>
              <ParsedText>{item.notes}</ParsedText>
              <StyledAttachments>
                <Attachments attachments={item.attachments} />
              </StyledAttachments>
            </>
          ),
        })),
      ]}
    />
  );
};
